import {Pipe, PipeTransform} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {TranslateService} from '@core/modules/translation/services/translate.service';

@Pipe({
	standalone: true,
	pure: false,
	name: 'inputError',
})
export class InputErrorPipe implements PipeTransform {
	constructor(private translate: TranslateService) {}

	transform(control: AbstractControl | null): string {
		if (!control) return '';
		if (!control.errors) return '';

		const errors = Object.entries(control.errors).map(([key, value]) => {
			switch (key) {
				case 'min':
					return this.translate.translate({key: 'FORMS.CONTROLS.ERRORS.MINIMUM', param: {value: value.min}});
				case 'max':
					return this.translate.translate({key: 'FORMS.CONTROLS.ERRORS.MAXIMUM', param: {value: value.max}});
				case 'minlength':
					return this.translate.translate({key: 'FORMS.CONTROLS.ERRORS.MINIMUM_LENGTH', param: {value: value.requiredLength}});
				case 'maxlength':
					return this.translate.translate({key: 'FORMS.CONTROLS.ERRORS.MAXIMUM_LENGTH', param: {value: value.requiredLength}});
				case 'required':
					return this.translate.translate('FORMS.CONTROLS.ERRORS.REQUIRED');
				case 'resolution':
					return this.translate.translate('FORMS.CONTROLS.ERRORS.UNKNOWN_RESOLUTION');
				case 'strictlyGreaterThan':
					return this.translate.translate('FORMS.CONTROLS.ERRORS.GREATER_THAN');
				case 'notPair':
					return this.translate.translate('FORMS.CONTROLS.ERRORS.PAIR_NUMBER');
				case 'invalidLanguageCode':
					return this.translate.translate('FORMS.CONTROLS.ERRORS.INVALID_LANGUAGE_CODE');
				default:
					return this.translate.translate('FORMS.CONTROLS.ERRORS.INVALID');
			}
		});

		return errors.join('. ');
	}
}
